import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "shield-save",
  "use": "shield-save-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"shield-save\"><style>#shield-save .st0{display:none}#shield-save .st0,#shield-save .st1{fill-rule:evenodd;clip-rule:evenodd}#shield-save .st2{filter:url(#Adobe_OpacityMaskFilter)}#shield-save .st3{fill-rule:evenodd;clip-rule:evenodd;fill:#fff}#shield-save .st4{mask:url(#mask-2_1_)}#shield-save .st5{filter:url(#Adobe_OpacityMaskFilter_1_)}#shield-save .st6{mask:url(#mask-2_3_);fill-rule:evenodd;clip-rule:evenodd}#shield-save .st7{display:none}</style><path class=\"st0\" d=\"M0 0h16v16H0z\" /><path class=\"st1\" d=\"M14.6 4.6V2.2c0-.2-.1-.4-.3-.5-2-.6-3.8-.9-6.1-1.2H8C6.8.6 5.7.7 4.7.9s-2 .5-2.9.8c-.2.1-.4.3-.4.5v2.2c-.1 5.6-.1 7.7 5.5 10.7.5.3.8.4 1.2.4.4 0 .7-.1 1.2-.3 5.4-3 5.4-4.8 5.3-10.6zm-2.9.8L7.3 9.9l-.1.1h-.6s-.1 0-.1-.1L4.3 7.6c-.2-.2-.2-.6 0-.8.2-.2.6-.2.8 0l1.8 1.8L11 4.5c.2-.2.6-.2.8 0 .1.3.1.6-.1.9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/shield-save.svg
// module id = IH71
// module chunks = 6